import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxBackgroundProps {
  imageUrl: string;
  overlayOpacity?: number;
  className?: string;
}
export function ParallaxBackground({
  imageUrl,
  overlayOpacity = 0.55,
  className = ''
}: ParallaxBackgroundProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  // Move background down slightly as we scroll down
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);
  return <div ref={ref} className={`absolute inset-0 overflow-hidden ${className}`} data-id="element-28">
      <motion.div style={{
      y,
      backgroundImage: `url(${imageUrl})`
    }} className="absolute inset-[-20%] bg-cover bg-center bg-no-repeat" data-id="element-29" />
      <div className="absolute inset-0 bg-apex-charcoal" style={{
      opacity: overlayOpacity
    }} data-id="element-30" />
    </div>;
}